/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AddRoleAssignment {
    getFixupPrototypeFunction() { return AddRoleAssignment.fixupPrototype; }

    static newInstance(model: Partial<AddRoleAssignment>): AddRoleAssignment {
        let obj = Object.assign(new AddRoleAssignment(), model);
        AddRoleAssignment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AddRoleAssignment>): AddRoleAssignment {
        if (!model) return null;
        return AddRoleAssignment.newInstance(<AddRoleAssignment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AddRoleAssignment) {
        if (!obj) return;

        models.AddRoleAssignment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AddRoleAssignment): boolean {
        Object.setPrototypeOf(obj, AddRoleAssignment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant within the CoreStack account
     */
    tenant_id: string;

    /**
     * Name of the Roles to be assigned to the user under a tenant
     */
    role_names: Array<string>;

}
